import { UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';

const hostname = window.location.hostname;
const port = window.location.port;
const protocol = window.location.protocol;
const getRightBaseUrl = (client: boolean) => {
  if (client) {
    if (hostname === 'localhost') {
      return protocol + '//' + hostname + ':' + port;
    } else {
      return protocol + '//' + hostname;
    }
  } else {
    if (hostname === 'localhost') {
      return protocol + '//' + hostname + ':8081';
    } else {
      return protocol + '//auth.' + hostname;
    }
  }
};
// OIDC configuration
export const oidcConfig: UserManagerSettings = {
  post_logout_redirect_uri: String(getRightBaseUrl(true) + process.env.REACT_APP_REDIRECT_URL),
  response_type: 'code',
  automaticSilentRenew: true,
  loadUserInfo: true,
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  authority: String(getRightBaseUrl(false) + process.env.REACT_APP_AUTH_URL),
  client_id: String(process.env.REACT_APP_IDENTITY_CLIENT_ID),
  redirect_uri: String(getRightBaseUrl(true) + process.env.REACT_APP_REDIRECT_URL),
  silent_redirect_uri: String(getRightBaseUrl(true) + process.env.REACT_APP_SILENT_REDIRECT_URL),
  scope: String('openid profile frontend_roles'),
};

// Create a UserManager instance
export const userManager = new UserManager(oidcConfig);

// Helper functions for authentication
export const login = async (): Promise<void> => {
  try {
    await userManager.signinRedirect();
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
};

export const logout = async (): Promise<void> => {
  try {
    await userManager.signoutRedirect();
  } catch (error) {
    console.error('Logout failed:', error);
    throw error;
  }
};

export const handleCallback = async (): Promise<void> => {
  try {
    await userManager.signinRedirectCallback();
  } catch (error) {
    console.error('Callback handling failed:', error);
    throw error;
  }
};

export const getUser = async (): Promise<any> => {
  try {
    return await userManager.getUser();
  } catch (error) {
    console.error('Failed to get user:', error);
    return null;
  }
};

export const isAuthenticated = async (): Promise<boolean> => {
  const user = await getUser();
  return !!user && !user.expired;
};
